import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Helmet from "../components/Helmet/Helmet";
import { subscribeToProducts } from "../services/productService";
import "../styles/home.css";
import { Container, Row, Col } from "react-bootstrap";
import heroImg from "../assets/images/hero-img.png";
import Services from "../services/Services";
import ProductsList from "../components/Ui/ProductsList";
import counterImg from "../assets/images/counter-timer-img.png";
import Clock from "../components/Ui/Clock";

function Home() {
  const [sofaProducts, setSofaProducts] = useState([]);
  const [chairProducts, setChairProducts] = useState([]);
  const [tableProducts, setTableProducts] = useState([]);
  const [lightingProducts, setLightingProducts] = useState([]);
  const [decorProducts, setDecorProducts] = useState([]);

  const year = new Date().getFullYear();

  useEffect(() => {
    const unsubscribe = subscribeToProducts((latest) => {
      const sofas = latest.filter((item) => item.category === "sofa");
      const chairs = latest.filter((item) => item.category === "chair");
      const tables = latest.filter((item) => item.category === "table");
      const lighting = latest.filter((item) => item.category === "lighting");
      const decor = latest.filter((item) => item.category === "decor");

      setSofaProducts(sofas);
      setChairProducts(chairs);
      setTableProducts(tables);
      setLightingProducts(lighting);
      setDecorProducts(decor);
    });

    return () => unsubscribe();
  }, []);

  return (
    <Helmet title={"Home | L'HABILLEUR Atelier"}>
      {/* Hero Showcase Section */}
      <section className="hero__section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg="6" md="6">
              <div className="hero__content">
                <p className="hero__subtitle">Curated Furniture Atelier &bull; {year}</p>
                <h1>Make Your Interior Minimalistic & Timeless</h1>
                <p className="hero__desc">
                  Discover refined furniture and architectural living pieces handcrafted with passionate Scandinavian craftsmanship, sustainable solid oak, and tactile natural textiles.
                </p>

                <Link to="/shop" className="buy__btn">
                  <span>Explore Furniture Collection</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Col>

            <Col lg="6" md="6">
              <div className="hero__img">
                <img
                  src={heroImg}
                  alt="L'Habilleur Showcase"
                  width="600"
                  height="380"
                  fetchpriority="high"
                  decoding="async"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Services />

      {/* 1. Sofas & Sectionals */}
      <section className="trending__products">
        <Container>
          <Row>
            <Col lg="12">
              <div className="section__header-wrap text-center">
                <span className="section__subtitle">Living Room Collection</span>
                <h2 className="section__title">Sofas & Sectionals</h2>
              </div>
            </Col>
            <ProductsList data={sofaProducts} />
          </Row>
        </Container>
      </section>

      {/* 2. Dining & Coffee Tables */}
      <section className="best__sales">
        <Container>
          <Row>
            <Col lg="12">
              <div className="section__header-wrap text-center">
                <span className="section__subtitle">Dining & Living Surfaces</span>
                <h2 className="section__title">Dining & Coffee Tables</h2>
              </div>
            </Col>
            <ProductsList data={tableProducts} />
          </Row>
        </Container>
      </section>

      {/* Limited Season Offer Hero */}
      <section className="py-2">
        <Container>
          <div className="timer__count">
            <Row className="align-items-center">
              <Col lg="6" md="12" className="count__down-col">
                <div className="clock__top-content">
                  <h4>Limited Atelier Commission</h4>
                  <h3>Handcrafted Nordic Armchair</h3>
                </div>
                <Clock />

                <Link to="/shop?category=chair" className="store__btn">
                  <span>Explore Armchairs</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </Col>
              <Col lg="6" md="12" className="text-end counter__img">
                <img
                  src={counterImg}
                  alt="Armchair offer"
                  width="450"
                  height="280"
                  loading="lazy"
                  decoding="async"
                />
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      {/* 3. Lounge & Accent Chairs */}
      <section className="new__arrivals">
        <Container>
          <Row>
            <Col lg="12">
              <div className="section__header-wrap text-center">
                <span className="section__subtitle">Sculptural Seating</span>
                <h2 className="section__title">Lounge & Accent Chairs</h2>
              </div>
            </Col>
            <ProductsList data={chairProducts} />
          </Row>
        </Container>
      </section>

      {/* 4. Designer Lighting & Accents */}
      <section className="popular__category">
        <Container>
          <Row>
            <Col lg="12">
              <div className="section__header-wrap text-center">
                <span className="section__subtitle">Ambiance & Fine Details</span>
                <h2 className="section__title">Lighting & Home Accents</h2>
              </div>
            </Col>
            <ProductsList data={[...lightingProducts, ...decorProducts]} />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
}

export default Home;
